import ExternalLink from 'components/ExternalLink/ExternalLink.component';
import styled from 'styled-components';

export const WrapperLink = styled(ExternalLink)`
  flex: 0 0 auto;

  svg {
    display: block;
  }
`;
